import { render, staticRenderFns } from "./conferenceInformation.vue?vue&type=template&id=3a0db2f5&scoped=true"
import script from "./conferenceInformation.vue?vue&type=script&lang=js"
export * from "./conferenceInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0db2f5",
  null
  
)

export default component.exports